export const EMPTY_OPTION_VALUE = "";
